"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDefaultApiScope = exports.AUTH_CALLBACK_PATHS = void 0;
const routes_1 = require("./routes");
exports.AUTH_CALLBACK_PATHS = {
    LEGACY: '/authorize',
    MODERN: `${routes_1.MODERN_BASE_PATH}/authorize`,
};
const getDefaultApiScope = (clientId) => `${clientId}/.default`;
exports.getDefaultApiScope = getDefaultApiScope;
